module.exports = __webpack_public_path__ + "img/p3_5.3077ce52.webp";